<template>
  <v-layout wrap v-if="content">
    <v-flex xs12>
      <v-select
        v-model="content.EffilabelShiftID"
        item-text="Name"
        item-value="ID"
        :items="shifts"
        label="Servicio"
        outlined
        @change="handleChangeIsModified"
        hide-details
        style="margin-bottom: 10px;"
      />
    </v-flex>
    <v-flex xs12>
      <v-select
        v-model="content.EffilabelDayOfWeek"
        item-text="Name"
        item-value="ID"
        :items="dayOfWeeks"
        label="D�a de la semana"
        outlined
        @change="handleChangeIsModified"
        hide-details
        style="margin-bottom: 10px;"
      />
    </v-flex>
    <v-flex xs12>
      <v-select
        v-model="content.EffilabelDay"
        item-text="Name"
        item-value="ID"
        :items="days"
        label="Hoy / ma�ana"
        outlined
        @change="handleChangeIsModified"
        hide-details
        style="margin-bottom: 10px;"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
export default {
  name: 'Form59Effilabel',
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    content: null,
    shifts: [],
  }),
  computed: {        
    ...mapState('app', ['locale']),
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
    dayOfWeeks () {
      return [
        { ID: null, Name: ''},
        { ID: 1, Name: 'Lunes'},
        { ID: 2, Name: 'Martes'},
        { ID: 3, Name: 'Mi�rcoles'},
        { ID: 4, Name: 'Jueves'},
        { ID: 5, Name: 'Viernes'},
        { ID: 6, Name: 'S�bado'},
        { ID: 0, Name: 'Domingo'},
      ]
    },
    days () {
      return [
        { ID: null, Name: ''},
        { ID: 'today', Name: 'Hoy' },
        { ID: 'tomorrow', Name: 'Ma�ana' },
      ]
    },
  },
  watch: {
    editedItem () {
      this.prepareContent()
    },
  },
  mounted () {
    this.prepareContent()
  },
  methods: {
    getShifts () {
      apiDtouch.getAll (`v1/private/workspaces/${this.workspaceID}/effilabel-shifts`)
        .then(response => {
          this.shifts = response.map(item => {
            item.Name = item.Name ? JSON.parse(item.Name) : null
            return {
              ID: item.ID,
              Name: item.Name ? item.Name.es || item.Name.en : '',
            }
          })
          this.shifts.unshift({ID: null, Name: ''})
        })
    },
    prepareContent () {
      this.content = this.editedItem
      this.getShifts()
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
  },
}
</script>

